<template>
  <div class="ad-immediate-area">
    <!--    头部-->
    <div class="flex align-center ad-immediate-header">
      <i class="iconfont iconguanggaokanban"></i>
      <span class="size14 area-tit">广告即时看板</span>
      <gj-help font-size="16px">
        数据来源：亚马逊广告API<br>
        计算公式：SP+SB+SD广告活动数据之和<br>
        使用说明：默认统计当前站点市场时间数据，由于亚马逊广告数据不稳定，订单类数据在72小时内会出现一定浮动变化
      </gj-help>
      <i class="iconfont iconshuaxin" @click="refresh"></i>
    </div>
    <!--    卡片组-->
    <div class="ad-immediate-card flex justify-between" v-loading="loading">
      <gj-card
          :title="`广告花费${summaryData.currencySymbol?'('+summaryData.currencySymbol+')':'($)'}`"
          :number="amountSymbol(summaryData.adsCost)"
          :border="false"
          padding="0 0 12px 0"
          width="33%"
          hasTip
      >
        <template #hasTip>
          商品广告花费：{{summaryData.sp.adsCost | defaultShow(summaryData.currencySymbol)}}<br>
          展示广告花费：{{summaryData.sd.adsCost | defaultShow(summaryData.currencySymbol)}}<br>
          品牌广告花费：{{summaryData.sb.adsCost | defaultShow(summaryData.currencySymbol)}}<br>
          总广告花费：{{summaryData.adsCost | defaultShow(summaryData.currencySymbol)}}<br>
        </template>
      </gj-card>
      <gj-card
          :title="`广告销售额${summaryData.currencySymbol?'('+summaryData.currencySymbol+')':'($)'}`"
          :number="amountSymbol(summaryData.adsSales)"
          :border="false"
          padding="0 0 12px 0"
          width="33%"
          hasTip
      >
        <template #hasTip>
          商品广告销售额：{{summaryData.sp.adsSales | defaultShow(summaryData.currencySymbol)}}<br>
          展示广告销售额：{{summaryData.sd.adsSales | defaultShow(summaryData.currencySymbol)}}<br>
          品牌广告销售额：{{summaryData.sb.adsSales | defaultShow(summaryData.currencySymbol)}}<br>
          总广告销售额：{{summaryData.adsSales | defaultShow(summaryData.currencySymbol)}}<br>
        </template>
      </gj-card>
      <gj-card
          title="广告订单量"
          :number="summaryData.adsOrders"
          :border="false"
          padding="0 0 12px 0"
          width="33%"
          hasTip
      >
        <template #hasTip>
          商品广告订单量：{{summaryData.sp.adsOrders | defaultShow}}<br>
          展示广告订单量：{{summaryData.sd.adsOrders | defaultShow}}<br>
          品牌广告订单量：{{summaryData.sb.adsOrders | defaultShow}}<br>
          总广告订单量：{{summaryData.adsOrders | defaultShow}}<br>
        </template>
      </gj-card>
      <gj-card
          title="ACOS"
          :number="summaryData.acos | defaultShow('','%')"
          :border="false"
          padding="0 0 15px 0"
          width="33%"
      ></gj-card>
      <gj-card
          title="ACOAS "
          :number="summaryData.acoas | defaultShow('','%')"
          :border="false"
          padding="0 0 15px 0"
          width="33%"
      ></gj-card>
      <gj-card
          title="ASOAS"
          :number="summaryData.asoas | defaultShow('','%')"
          :border="false"
          padding="0 0 15px 0"
          width="33%"
      ></gj-card>
    </div>

    <gj-radio-group
        v-model="activeName"
        :options="[
                  {id: 'acos', text: 'ACOS排名'},
                  {id: 'ctr', text: 'CTR排名'},
                  {id: 'cvr', text: 'CVR排名'},
              ]"
        style="width: 100%;"
        class="flex"
    ></gj-radio-group>

<!--    &lt;!&ndash;    表格tab&ndash;&gt;-->
<!--    <el-tabs v-model="activeName">-->

      <div class="flex align-center justify-between" style="margin-top: 10px;">

        <el-tabs v-model="tableType">
          <el-tab-pane label="活动" name="campaign"></el-tab-pane>
          <el-tab-pane label="关键词" name="keyword"></el-tab-pane>
        </el-tabs>

<!--        <gj-radio-group-->
<!--            v-model="tableType"-->
<!--            :options="[-->
<!--                  {id: 'campaign', text: '活动'},-->
<!--                  {id: 'keyword', text: '关键词'}-->
<!--              ]"-->
<!--        ></gj-radio-group>-->

        <div class="size12 color999">
            <span>
              <i class="iconfont iconshangsheng1 size12 colorGreen"></i>
              环比上升
            </span>
          <span style="margin: 0 16px">
              <i class="iconfont iconxiajiang size12 colorRed"></i>
              环比下降
            </span>
          <span>
              <i class="iconfont iconhengxian size12"></i>
              环比持平
            </span>
        </div>
      </div>

<!--      <el-tab-pane label="ACOS排名" name="acos">-->
        <acos-rank
            v-if="showAdMask&&activeName==='acos'"
            ref="acosTable"
            name="acos"
            :activeName="activeName"
            :tableType="tableType"
            :columns="acosColumns"
            :currencySymbol="summaryData.currencySymbol"
        ></acos-rank>
<!--      </el-tab-pane>-->
<!--      <el-tab-pane label="CTR排名" name="ctr" lazy>-->
        <acos-rank
            v-if="showAdMask&&activeName==='ctr'"
            ref="ctrTable"
            name="ctr"
            :activeName="activeName"
            :tableType="tableType"
            :columns="ctrColumns"
            :currencySymbol="summaryData.currencySymbol"
        ></acos-rank>
<!--      </el-tab-pane>-->
<!--      <el-tab-pane label="CVR排名" name="cvr" lazy>-->
        <acos-rank
            v-if="showAdMask&&activeName==='cvr'"
            ref="cvrTable"
            name="cvr"
            :activeName="activeName"
            :tableType="tableType"
            :columns="cvrColumns"
            :currencySymbol="summaryData.currencySymbol"
        ></acos-rank>
<!--      </el-tab-pane>-->

<!--    </el-tabs>-->

    <app-mask authType="ads" linkText="立即广告授权"></app-mask>
  </div>
</template>

<script>
import acosRank from "@/views/modules/home/dashboard/components/ad-immediate-board/components/ACOS-rank.vue"
import {amountSymbol} from "@/filters";
import AppMask from "@/views/modules/home/components/mask/mask";
import {currentSummary} from "@/api/dashboard";
import {dashboardMixin, queryMixin} from "@/minxins";
import {mapGetters} from "vuex";
import {isMeaningful, isMeaningless} from "@/utils/common";

export default {
  name: "ad-immediate-board",
  mixins: [queryMixin, dashboardMixin],
  components:{acosRank,AppMask},
  data() {
    return {
      loading: false,
      activeName: 'acos',
      tableType:'campaign',
      summaryData:{
        sp:{},
        sb:{},
        sd:{}
      },
      acosColumns: [
        {id: 'rank', header: '排名', field: 'slot:rank', width: '45px'},
        this.tableType === 'keyword' ? {id: 'keyword', header: 'slot:campaignName', field: 'slot:campaignName', scale: 2, minWidth: '120px',}
            : {id: 'campaignName', header: 'slot:campaignName', field: 'slot:campaignName', scale: 2, minWidth: '120px',},
        {id: 'adsCost', header: 'slot:adsCost', field: 'adsCost', minWidth: '80px', align: 'right'},
        {id: 'adsSales', header: 'slot:adsSales', field: 'adsSales', minWidth: '85px', align: 'right'},
        {id: 'acos', header: 'ACOS', field: 'slot:acos', suffix: '%', minWidth: '110px', sortable: true, align: 'right'}
      ],
      ctrColumns:[
        {id: 'rank', header: '排名', field: 'slot:rank', width: '45px'},
        this.tableType === 'keyword' ? {id: 'keyword', header: 'slot:campaignName', field: 'slot:campaignName', scale: 2, minWidth: '120px',}
            : {id: 'campaignName', header: 'slot:campaignName', field: 'slot:campaignName', scale: 2, minWidth: '120px',},
        {id: 'adsImpressions', header: '曝光量', field: 'adsImpressions', minWidth: '80px', align: 'right'},
        {id: 'adsClicks', header: '点击量', field: 'adsClicks', minWidth: '85px', align: 'right'},
        {id: 'ctr', header: 'CTR', field: 'slot:ctr', suffix: '%', minWidth: '110px', sortable: true, align: 'right'}
      ],
      cvrColumns:[
        {id: 'rank', header: '排名', field: 'slot:rank', width: '45px'},
        this.tableType === 'keyword' ? {id: 'keyword', header: 'slot:campaignName', field: 'slot:campaignName', scale: 2, minWidth: '120px',}
            : {id: 'campaignName', header: 'slot:campaignName', field: 'slot:campaignName', scale: 2, minWidth: '120px',},
        {id: 'adsClicks', header: '点击量', field: 'adsClicks', minWidth: '80px', align: 'right'},
        {id: 'adsOrders', header: '广告订单量', field: 'adsOrders', minWidth: '85px', align: 'right'},
        {id: 'cvr', header: 'CVR', field: 'slot:cvr', suffix: '%', minWidth: '110px', sortable: true, align: 'right'}
      ]
    }
  },
  methods: {
    amountSymbol,
    $gjQuery(){
      if(!this.showAdMask){
        return
      }
      // 缓存了时区时，第一次不请求
      if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
        return
      }
      this.loading = true;
      currentSummary(
          `?currency=${this.dashboardCurrency}&dateTime=${this.timezoneText}&countrys=${this.countryMarket.countryIds.join(',')}&marketIds=${this.countryMarket.marketIds.join(',')}`
      ).then(data=>{
        this.summaryData = {
          ...data,
          sp: data.summaryByType ? data.summaryByType.find(r=>r.adType === 0) : {},
          sb: data.summaryByType ? data.summaryByType.find(r=>r.adType === 1) : {},
          sd: data.summaryByType ? data.summaryByType.find(r=>r.adType === 2) : {},
        };
      }).complete(()=>{this.loading = false})
    },
    refresh(){
      this.$gjQuery()
      if(this.activeName === 'acos'){
        this.$refs.acosTable.$gjQuery()
      }else if(this.activeName === 'ctr'){
        this.$refs.ctrTable.$gjQuery()
      }else if(this.activeName === 'cvr'){
        this.$refs.cvrTable.$gjQuery()
      }

    }
  }
}
</script>

<style scoped lang="scss">
.ad-immediate-area {
  position: relative;
  padding: 0 20px 10px;
  background: #fff;
  border-radius: 4px;
  height: 566px;
  box-sizing: border-box;
}

.ad-immediate-header {
  height: 50px;
}

.ad-immediate-card {
  flex-wrap: wrap;
  height: 138px;
}

/deep/ .el-tabs__item {
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  padding: 0 12px 0 0 !important;
  color: #666;
}

/deep/ .el-tabs__item.is-active {
  color: #1F6EEF;
  //font-weight: 600;
}

/deep/ .el-tabs__item + .el-tabs__item {
  border-left: 1px solid #E4E5E6;
  padding-left: 12px!important;
}

/deep/ .el-tabs__nav {
  padding: 4px 0;
  height: 16px;
  line-height: 16px;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}
/deep/ .el-radio-button{
  flex: 1;
 .el-radio-button__inner{
   padding: 5px 16px;
   width: 100%;
  }
}

/deep/.gj-card-title{
  color: #666!important;
}
.iconshangsheng1,.iconxiajiang,.iconhengxian{
  display: inline-block;
  transform: scale(.9);
}
</style>